.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  min-height: 300px;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: auto;
}
